module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cheatManage"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("作弊管理\n        "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "selectSchool"
  }, [_c('el-select', {
    staticClass: "selectInput",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择校区"
    },
    model: {
      value: (_vm.region),
      callback: function($$v) {
        _vm.region = $$v
      },
      expression: "region"
    }
  }, _vm._l((_vm.option), function(item) {
    return _c('el-option', {
      key: item.unid,
      attrs: {
        "label": item.name,
        "value": item.unid
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "formdata"
  }, [_c('el-form', {
    ref: "cheatForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.cheatForm
    }
  }, [_c('el-form-item', {
    staticClass: "time",
    attrs: {
      "prop": "startTime"
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "请选择开始时间"
    },
    model: {
      value: (_vm.cheatForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.cheatForm, "startTime", $$v)
      },
      expression: "cheatForm.startTime"
    }
  })], 1), _vm._v("\n              至  \n            "), _c('el-form-item', {
    staticClass: "time",
    attrs: {
      "prop": "endTime"
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "请选择结束时间"
    },
    model: {
      value: (_vm.cheatForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.cheatForm, "endTime", $$v)
      },
      expression: "cheatForm.endTime"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("\n                同一设备一天内登录\n                "), _c('el-form-item', {
    staticClass: "number",
    attrs: {
      "prop": "number"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.cheatForm.number),
      callback: function($$v) {
        _vm.$set(_vm.cheatForm, "number", $$v)
      },
      expression: "cheatForm.number"
    }
  })], 1), _vm._v("\n                个账户，认为有作弊嫌疑！\n            ")], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e741444c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiaoyuan/GX/cheatManage.vue
// module id = 1136
// module chunks = 0